import { MsalProvider } from "@azure/msal-react";
import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ChartContextProvider from "./Context/ChartContextProvider";
import CommentContextProvider from "./Context/CommentContext/CommentContextProvider";
import ConfigurationContextProvider from "./Context/ConfigrationContext/ConfigurationContextProvider";
import DashboardContextProvider from "./Context/DashboardContext/DashboardContextProvider";
import ManagerReportContextProvider from "./Context/ManagerReportContext/ManagerReportContextProvider";
import AuditorHome from "./components/Auditor/index";
import AdAuthRedirect from "./components/Auth/Middleware/AdAuthRedirect";
import AuthProvider from "./components/Auth/Middleware/AuthProvider";
import PR from "./components/Auth/Middleware/ProtectedRoute";
import SignIn from "./components/Auth/SignIn/Index";
import ChartDetails from "./components/ChartDetails/ChartDetails";
import UserHome from "./components/Coder/Index";
import CoderProfile from "./components/CoderProfile/CoderProfile";
import Configuration from "./components/Configuration/index";
import Index from "./components/Dashboard/Index";
import Layout from "./components/Layout/Layout";
import ManagerReports from "./components/Manager/ManagerReports/Index";
import UserList from "./components/Manager/ManagerUsers/Index";
import ManagerUsersProfile from "./components/Manager/ManagerUsersProfile";
import WorkList from "./components/Manager/ManagerWorkLists/Index";
import WorklistDetails from "./components/Manager/ManagerWorklistDetails/Index";
import MarkAttendance from "./components/Modal/MarkAttendance";
import HCCSpeciality from "./components/HCCSpeciality";

function App({ instance }) {
  return (
    <>
      <MsalProvider instance={instance}>
        <AuthProvider>
          <Router>
            <Routes>
              <Route exact path="/login" element={<SignIn />} />
              <Route exact path="/redirect" element={<AdAuthRedirect />} />
              <Route element={<Layout />}>
                {/* PR - Protected Routes */}
                <Route exact path="/user/mark-attendance" element={ <PR>  <MarkAttendance /> </PR> } />
                <Route exact path="/" element={ <PR>  <UserHome /> </PR> } />
                <Route exact path="/process-chart/:id" element={ <PR>  <ChartContextProvider>  <CommentContextProvider>  <ChartDetails /> </CommentContextProvider> </ChartContextProvider> </PR> } />
                <Route exact path="/coder-profile" element={ <PR>  <CoderProfile /> </PR> } />
                <Route exact path="/auditor-home" element={ <PR>  <ChartContextProvider>  <CommentContextProvider>  <AuditorHome /> </CommentContextProvider> </ChartContextProvider> </PR> } />
                <Route exact path="/manager-worklist" element={ <PR>  <ChartContextProvider>  <CommentContextProvider>  <WorkList /> </CommentContextProvider> </ChartContextProvider> </PR> } />
                <Route exact path="/audit-worklist" element={ <PR>  <ChartContextProvider>  <CommentContextProvider>  <WorkList /> </CommentContextProvider> </ChartContextProvider> </PR> } />
                <Route exact path="/manager-worklist-details" element={ <PR>  <ChartContextProvider>  <CommentContextProvider>  <WorklistDetails /> </CommentContextProvider> </ChartContextProvider> </PR> } />
                <Route exact path="/auditor-worklist-details" element={ <PR>  <ChartContextProvider>  <CommentContextProvider>  <WorklistDetails /> </CommentContextProvider> </ChartContextProvider> </PR> } />
                <Route exact path="/manager-reports" element={ <PR>  <ManagerReportContextProvider>  <CommentContextProvider>  <ManagerReports /> </CommentContextProvider> </ManagerReportContextProvider> </PR> } />
                <Route exact path="/configuration" element={ <PR> <ConfigurationContextProvider> <Configuration /> </ConfigurationContextProvider> </PR> } />
                <Route exact path="/manager-userlist" element={ <PR>  <ChartContextProvider>  <CommentContextProvider>  <UserList /> </CommentContextProvider> </ChartContextProvider> </PR> } />
                <Route exact path="/manager-users-profile" element={ <PR>  <ChartContextProvider>  <CommentContextProvider>  <ManagerUsersProfile /> </CommentContextProvider> </ChartContextProvider> </PR> } />
                <Route exact path="/dashboard" element={<PR>  <DashboardContextProvider>  <CommentContextProvider>  <Index /> </CommentContextProvider> </DashboardContextProvider> </PR>} />
                <Route exact path="/hcc-speciality" element={ <PR><HCCSpeciality /> </PR> } />
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </MsalProvider>
    </>
  );
}

export default App;
